import { ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { ErrorBoundary } from 'components/ErrorBoundary';

import { Toaster } from './Toast';
import { WindowSizeProvider } from './WindowSize/WindowSize';
import { AuthProvider } from './Auth/Provider';
// import { Tracking } from './Tracking/Tracking';

const queryClient = new QueryClient();

export function AppProvider({ children }: { children: ReactNode }) {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <WindowSizeProvider>
            <AuthProvider>
              <>{children}</>

              <Toaster />
              {/* <Tracking /> */}
            </AuthProvider>
          </WindowSizeProvider>
        </QueryClientProvider>
      </ErrorBoundary>
    </BrowserRouter>
  );
}
